<!--
 * @Author: M.D.
 * @Date: 2020-01-10 10:56:10
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="news-detail-o-w">
    <div class="nd-content-a bShadow-5" v-show="article.title">
      <div class="nd-cl-a-title">{{ article.title }}</div>
      <div class="nd-cl-a-info">
        <span class="nd-source">来源：{{ article.source }}</span>
        <span class="nd-date">发布时间：{{ article.releaseTime }}</span>
      </div>
      <div class="nd-cl-a-content" v-html="article.description"></div>
    </div>
    <div class="nd-content-r bShadow-5">
      <div class="nd-r-title">相关文章</div>
      <ul class="nd-r-ul">
        <li
          v-for="a in relatedArticles"
          :key="a.id"
          @click="relatedNewsDetail(a)"
        >
          <div class="dot"></div>
          {{ a.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'

export default {
  props: {},
  data() {
    return {
      article: {},
      relatedArticles: [],
    }
  },
  computed: {},
  created() {
    this.getNewsDetail()
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  destroyed() {
    this.article = {}
  },
  methods: {
    relatedNewsDetail(news) {
      this.$router.replace({
        name: 'news-detail',
        params: { newsId: news.id },
      })
    },
    async getNewsDetail() {
      const re = await API.getNewsDetail(this.$route.params.newsId)
      this.article = re.data.result
      await this.updateRelatedArticles()
    },
    async updateRelatedArticles() {
      const query = {
        currentPage: 1,
        pageSize: 10,
        type: this.article.type,
      }
      const re = await API.getNewsListByType(query)
      let alist = this._.clone(re.data.result.records)
      this._.remove(alist, (a) => {
        return a.id === this.article.id
      })
      this.relatedArticles = alist
    },
  },
  components: {},
}
</script>

<style lang="stylus">
.news-detail-o-w {
  width: 1200px;
  margin: auto;
  display: flex;

  >div {
    width: 100%;
    background-color: #ffffff;
    padding: 20px;
  }

  .nd-content-a {
    width:900px;
    box-sizing: border-box;
    margin-right: 30px;

    .nd-cl-a-title {
      font-size: 22px;
      color: #444444;
      line-height: 28px;
      margin: 10px 0;
    }

    .nd-cl-a-info {
      color: #C6C6C6;
      font-size: 14px;
      margin: 20px 0;

      .nd-source {
        margin-right: 30px;
      }

      .nd-date {
        margin-left: 10px;
      }
    }

    .nd-cl-a-content {
      // overflow scroll
      min-height: 500px;
    }
  }

  .nd-content-r {
    width:270px;
    min-height: 450px;
    height: max-content;
    box-sizing: border-box;
    .nd-r-title {
      margin: 10px 0;
    }

    .nd-r-ul {
      margin: 15px 0;

      li {
        padding-left: 16px;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        color: #333333;

        .dot {
          display: inline-block;
          line-height: 40px;
          vertical-align: middle;
          margin-right: 16px;
          width: 5px;
          height: 5px;
          background: #31A826;
          border-radius: 2.5px;
        }
      }
    }
  }
}
</style>
